export default "__VITE_ASSET__Df8UjQ_j__"